import { FunctionComponent, h } from 'preact';
import { useStore } from '../../helpers/use-store';
import { observer } from 'mobx-react';
import ScheduleContent from './schedule-content/schedule-content';
import { Mobile, TabletAndDesktop } from '../../responsive-devices/responsive-devices';
import SharedLocationLayout from '../../pages/shared-location-layout/shared-location-layout';
import { get as _get } from 'lodash';

const Schedule: FunctionComponent = observer(() => {
	const { scheduleStore } = useStore();

	const {
		customerExperience,
		deliveryWindows,
		deliveryWindow,
		setDeliveryWindow,
		setContactNotifications,
		schedule,
		isScheduled,
		contactNotifications,
		setApproveTermsAndConditions,
		enableContactNotificationEdit,
		couldSubmitContactNotifications
	} = scheduleStore;

	const { task, customer, ui_data, opt_in_out_data } = customerExperience;

	const isScheduleButtonDisabled = !deliveryWindow || !couldSubmitContactNotifications;

	const customerName = _get(customer, 'name');
	const externalId = _get(task, 'external_id');
	const timezone = _get(ui_data, 'timezone');
	const languageCode = _get(ui_data, 'languageCode');

	const scheduleContentProps = {
		customerName: customerName,
		deliveryWindows,
		selectedDeliveryWindow: deliveryWindow,
		onDeliveryWindowSelect: setDeliveryWindow,
		isScheduleButtonDisabled,
		onSchedule: schedule,
		externalId: externalId,
		isScheduled,
		enableContactNotificationEdit,
		onContactNotificationsChange: setContactNotifications,
		onTermsChange: setApproveTermsAndConditions,
		optInOutData: {
			...contactNotifications,
			terms_and_conditions_text: _get(opt_in_out_data, 'terms_and_conditions_text')
		},
		locale: languageCode,
		timezone
	};

	return (
		<SharedLocationLayout>
			<div className="schedule" data-testid="schedule">
				<Mobile>
					<ScheduleContent {...scheduleContentProps} />
				</Mobile>

				<TabletAndDesktop>
					<card-component className="schedule-card">
						<ScheduleContent {...scheduleContentProps} />
					</card-component>
				</TabletAndDesktop>
			</div>
		</SharedLocationLayout>
	);
});

export default Schedule;
